<template lang="pug">
  #question-answers
    .block(v-if="question.type === 'radio'")
      div(v-for="item of getArrayOfFields")
        //- wellness questions object.value are "wrong"/"right" and the object.key is the text value we need to show
        BRadio.is-size-6.m-1(
          size="is-small"
          v-model="answer"
          :native-value="item.key"
          :disabled="disabled"
        )
          span {{ getAnswerValue(item) }}
          span.pl-2(v-if="showAnswers")
            span.has-text-danger(v-if="item.value === 'wrong'") x
            span.has-text-green(v-if="item.value === 'right'") &#10003;
    .block(v-if="question.type === 'checkbox'")
      div(v-for="item of getArrayOfFields")
        BCheckbox.is-size-6.m-1(
          type="is-info"
          size="is-small"
          v-model="multipleAnswers"
          :native-value="item.value"
          :name="item.key"
          :disabled="disabled"
        ) {{ item.value }}
    .block(v-if="question.type === 'dropdown'")
      BSelect.is-size-6.m-1(
        placeholder="Select One"
        v-model="answer"
        :disabled="disabled"
      )
        option(
          v-for="item of getArrayOfFields"
          :key="item.key"
          :value="item.value"
        ) {{ item.value }}
    .block(v-if="question.type === 'text'")
      BInput.is-size-6.m-1(
        type="textarea"
        rows="3"
        v-model="answer"
        :disabled="disabled"
      )
    .block(
      v-if="question.type === 'range'"
    ).mb-6
      BSlider(
        :min="parseInt(question.fields.range_start)"
        :max="parseInt(question.fields.range_end)"
        :disabled="disabled"
        :value="parseInt(answer)"
        indicator
        :tooltip="false"
        lazy
        @change="sliderInputChange"
      ).px-4
        BSliderTick.tick(:value="parseInt(question.fields.range_start)") {{question.fields.range_start}}
        BSliderTick.tick(:value="parseInt(question.fields.range_end)") {{question.fields.range_end}}
</template>

<script>
import { questionMixin } from "@/mixins/questionMixin";

export default {
  name: "QuestionPreviewAnswer",

  mixins: [questionMixin],

  props: {
    question: {
      type: Object,
      required: true
    },

    showAnswers: {
      type: Boolean,
      default: false
    },

    previewAnswer: {
      type: [String, Number, Array],
      default: null
    },

    defaultAnswer: {
      type: [String, Number, Array],
      default: null
    }
  },

  data() {
    let initialAnswer = this.previewAnswer || null;
    let initialMultipleAnswer = this.previewAnswer || [];
    if (this.defaultAnswer) {
      initialAnswer = this.defaultAnswer.toLowerCase();
      initialMultipleAnswer = this.defaultAnswer;
    }
    return {
      answer: initialAnswer,
      multipleAnswers: initialMultipleAnswer
    };
  },

  computed: {
    getArrayOfFields() {
      const array = [];

      if (typeof this.question.fields === "string") {
        const items = this.question.fields.split("\n##");
        items[0] = items[0].replace("##", "");
        items.forEach((val, index) => {
          array.push({ key: index.toString(), value: val });
        });
      } else {
        const options =
          this.question.type === "range"
            ? this.question.fields.values
            : this.question.fields;
        for (const [key, val] of Object.entries(options)) {
          array.push({ key: key, value: val });
        }
      }

      return array;
    },
    disabled() {
      if (this.question.type != "range") {
        return !!this.previewAnswer;
      } else if (this.previewAnswer != null) {
        return true;
      } else {
        return false;
      }
    }
  },

  watch: {
    answer: {
      handler: function(answer) {
        this.emitAnswerEvent(answer);
      },
      immediate: false
    },
    multipleAnswers: {
      handler: function(answers) {
        this.emitAnswerEvent(answers);
      },
      immediate: false
    }
  },
  methods: {
    emitAnswerEvent(answer) {
      this.$emit("onAnswer", {
        questionId: this.question.id,
        answer: answer
      });
    },
    sliderInputChange(val) {
      this.answer = val;
    }
  }
};
</script>

<style lang="sass" scoped>
#question-answers
  margin-top: 10px
  .option
    margin: 10px
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    font-size: $size-normal
    .b-radio.radio
      margin: 4px
.tick
  margin-top: 20px
  font-family: $family-sans-serif-bold
.b-checkbox
  /deep/ span.check
    border-radius: $radius-small !important
</style>
